module.exports = __webpack_public_path__ + "img/Icon_Most_Turnover.4e6d45e5.png";